import { NotFound, ProtectedRoute } from "@fdoh/health-ui-react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import InspectionHomePage from "../InspectionHome/InspectionHome";
import CreateSetBacksPage from "./CreateSetBacksForm";
import EditSetBacksPage from "./EditSetBacksInspectionForm";
import HomePage from "../Home/Home";

export const SetBacksInspectionModule = () => {
  let { path } = useRouteMatch();

  return (
    
      <Switch>
        <ProtectedRoute exact path={path}>
              <CreateSetBacksPage />
        </ProtectedRoute> 
        <ProtectedRoute exact path={`${path}/:id(\\d+)`}>
          <EditSetBacksPage />
        </ProtectedRoute> 
        <Route>
          <NotFound />
        </Route>
      </Switch>
    
  );
};

export default SetBacksInspectionModule;
